/**
 * AylarLLM Theme Core JavaScript
 * Handles terminal tab toggles, quick copy to clipboard, variant switching & quantity controls
 */

document.addEventListener('DOMContentLoaded', () => {
  initCodeTabs();
  initCopyButtons();
  initQuantityControls();
  initMobileMenu();
});

// Switch tabs inside code/terminal blocks
function initCodeTabs() {
  document.querySelectorAll('.terminal-window, .code-snippet-box').forEach(box => {
    const tabs = box.querySelectorAll('.terminal-tab-btn, .code-tab-btn');
    const panes = box.querySelectorAll('.terminal-pane, .code-pane');

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        panes.forEach(p => p.style.display = 'none');

        tab.classList.add('active');
        if (panes[index]) {
          panes[index].style.display = 'block';
        }
      });
    });
  });
}

// Copy code snippets to clipboard with feedback tooltip
function initCopyButtons() {
  document.querySelectorAll('.terminal-copy-btn, .btn-copy-code').forEach(btn => {
    btn.addEventListener('click', async () => {
      const parent = btn.closest('.terminal-window') || btn.closest('.code-snippet-box');
      if (!parent) return;

      const activePane = parent.querySelector('.terminal-pane:not([style*="display: none"]), .code-pane:not([style*="display: none"])') || parent.querySelector('.terminal-body') || parent.querySelector('code');
      if (!activePane) return;

      const text = activePane.innerText;
      try {
        await navigator.clipboard.writeText(text);
        const originalHtml = btn.innerHTML;
        btn.innerHTML = `<span>Copied!</span>`;
        btn.classList.add('copied');
        setTimeout(() => {
          btn.innerHTML = originalHtml;
          btn.classList.remove('copied');
        }, 2000);
      } catch (err) {
        console.error('Failed to copy to clipboard', err);
      }
    });
  });
}

// Quantity selector increment / decrement
function initQuantityControls() {
  document.querySelectorAll('.quantity-wrapper').forEach(wrapper => {
    const input = wrapper.querySelector('.qty-input');
    const minus = wrapper.querySelector('.qty-minus');
    const plus = wrapper.querySelector('.qty-plus');

    if (!input) return;

    if (minus) {
      minus.addEventListener('click', () => {
        let val = parseInt(input.value, 10) || 1;
        if (val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change'));
        }
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        let val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });
}

// Mobile menu toggle
function initMobileMenu() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.querySelector('.nav-desktop');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isVisible = nav.style.display === 'flex';
      nav.style.display = isVisible ? 'none' : 'flex';
      if (!isVisible) {
        nav.style.flexDirection = 'column';
        nav.style.position = 'absolute';
        nav.style.top = '100%';
        nav.style.left = '0';
        nav.style.right = '0';
        nav.style.background = '#0d121d';
        nav.style.padding = '1.5rem';
        nav.style.borderBottom = '1px solid rgba(255,255,255,0.1)';
      }
    });
  }
}
